<ng-container *ngIf="params && values !== undefined && values !== null">
	<ng-container *ngFor="let value of values">
		{{ value }}
		<br>
	</ng-container>
</ng-container>
